import { PageHeader } from '@/app/layouts/PageHeader'
import type { NotificationKind } from '@/api/types'
import { CenteredSpinner } from '@/components/ui/Spinner'
import { SettingsSection, Toggle, usePreferences, useUpdatePreferences } from '@/features/settings'
import { useT } from '@/i18n'
import type { MessageKey } from '@/i18n'

const kinds: { kind: NotificationKind; label: MessageKey; description: MessageKey }[] = [
  { kind: 'reply', label: 'notifPref.reply', description: 'notifPref.replyDesc' },
  { kind: 'mention', label: 'notifPref.mention', description: 'notifPref.mentionDesc' },
  { kind: 'quote', label: 'notifPref.quote', description: 'notifPref.quoteDesc' },
  { kind: 'repost', label: 'notifPref.repost', description: 'notifPref.repostDesc' },
  { kind: 'like', label: 'notifPref.like', description: 'notifPref.likeDesc' },
  { kind: 'follow', label: 'notifPref.follow', description: 'notifPref.followDesc' },
]

export function SettingsNotificationsPage() {
  const t = useT()
  const { data: prefs, isPending, isError } = usePreferences()
  const update = useUpdatePreferences()

  return (
    <>
      <PageHeader title={t('settings.notifications')} back />
      {isPending && <CenteredSpinner />}
      {isError && (
        <p className="px-4 py-6 text-[15px] text-ink-muted">{t('notifPref.loadFailed')}</p>
      )}
      {prefs && (
        <>
          <SettingsSection title={t('notifPref.filter')}>
            <Toggle
              label={t('notifPref.followingOnly')}
              description={t('notifPref.followingOnlyDesc')}
              checked={prefs.notify_following_only}
              onChange={(checked) => update.mutate({ notify_following_only: checked })}
            />
          </SettingsSection>

          <SettingsSection title={t('notifPref.types')} description={t('notifPref.typesDesc')}>
            <div className="divide-y divide-line">
              {kinds.map(({ kind, label, description }) => (
                <Toggle
                  key={kind}
                  label={t(label)}
                  description={t(description)}
                  checked={prefs.notifications[kind]}
                  onChange={(checked) => update.mutate({ notifications: { [kind]: checked } })}
                />
              ))}
            </div>
          </SettingsSection>

          <p className="px-4 py-3 text-[13px] text-ink-muted">{t('notifPref.footnote')}</p>
        </>
      )}
    </>
  )
}
